import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type Props = {
  open: boolean;
  requestNo: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export function TransferShipConfirmDialog({
  open,
  requestNo,
  loading,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && !loading && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>ຢືນຢັນຈັດສົ່ງ</DialogTitle>
          <DialogDescription>
            {requestNo} — ລະບົບຈະຕັດ lot ທີ່ Hub ຕາມ FEFO (ໝົດອາຍຸກ່ອນ)
            ອັດຕະໂນມັດ · ຍ້ອນຫຼັງໄດ້ຍາກ.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            ຍົກເລີກ
          </Button>
          <Button isLoading={loading} onClick={() => void onConfirm()}>
            ຢືນຢັນສົ່ງ
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
